<template>
  <div class="pc-item">
    <div class="pc-item-img">
      <img
          v-if="obj.coverImage!=null&&obj.coverImage!=''&&obj.coverImage!=undefined"
          :src="obj.coverImage"
          alt
      />
    </div>
    <div class="pc-item-info">
      <div class="pc-info-name">{{obj.courseName || '暂无名称'}}</div>
      <div class="pc-info-time">{{obj.createTime}}</div>
      <div class="pc-info-source">{{obj.schoolName}}{{obj.gradeName}}{{obj.teacherName}}上传</div>
      <div class="pc-info-unapproved" v-if="releaseShow && obj.isStart === '1'">待审核</div>
      <div class="pc-info-examine" v-if="releaseShow && obj.isStart === '0'">已审核</div>
    </div>
    <div class="pc-item-btns" v-if="isIdentity === '1'">
      <span class="pc-btn green" v-if="releaseShow && obj.isStart === '1'" @click="clickFn('release')">发布</span>
      <span class="pc-btn yellow" @click="clickFn('editFn')">编辑</span>
      <!-- <span class="pc-btn red" @click="clickFn('deleteRow')">删除</span> -->
      <span class="pc-btn blue" @click="clickFn('download')">下载</span>
    </div>
    <div class="pc-item-btns" v-else>
      <span class="pc-btn green" @click="clickFn('lookFn')">观看课程</span>
    </div>
  </div>
</template>

<script>
	export default {
		name: "curriculumList",
    props:['obj','releaseShow','isIdentity'],
    data() {
			return {}
    },
    methods:{
			clickFn(type) {
				this.$emit(type, this.obj)
      },
    },
	}
</script>

<style lang="less" scoped>
  .pc-item{
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 120px;
    padding: 10px 0;
    .pc-item-img{
      width: 18%;
      height: 100%;
      border: 1px solid #cecece;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .pc-item-info{
      flex: 1;
      font-size: 14px;
      color: #333;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 20px;
      .pc-info-name{
        font-weight: bold;
      }
      .pc-info-source{
        color: #6d7277;
      }
      .pc-info-unapproved{
        font-size: 16px;
        font-weight: bolder;
        color: #ffb93a;
      }
      .pc-info-examine{
        font-size: 16px;
        font-weight: bolder;
        color: #1ec78d;
      }
    }
    .pc-item-btns{
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      & > span{
        display: inline-block;
        padding: 5px 26px;
        border: 1px solid;
        border-radius: 3px;
        cursor: pointer;
      }
      .pc-btn.green:hover{
        background-color: #1ec78d;
        color: #fff;
      }
      .green{
        border-color: #1ec78d;
        color: #1ec78d;
      }
      .pc-btn.yellow:hover{
        background-color: #ffc743;
        color: #fff;
      }
      .yellow{
        border-color: #ffc743;
        color: #ffc743;
      }
      .pc-btn.red:hover{
        background-color: #f7545e;
        color: #fff;
      }
      .red{
        border-color: #f7545e;
        color: #f7545e;
      }
      .blue{
        border-color: #409eff;
        color: #409eff;
      }
    }
  }
</style>